<template>
  <el-form ref="form_post" :model="form_post" label-width="0px" @submit.native.prevent>
    <div class="side-search-form-box">
      <div class="side-search-form-title" :class="[dark_mode ? 'dark' : '']">キーワード検索</div>
      <el-input
        v-model="form_post.keyword"
        placeholder="キーワード/ハッシュタグで検索"
        :trigger-on-focus="false"
        clearable
        class="side-search-form-input"
        :class="dark_mode ? 'dark' : ''"
        style="margin-bottom:0"
        @input="resultCount()"
        size="small"
      ></el-input>
    </div>
    <div>
      <div class="side-search-form-box">
        <div class="side-search-form-title">性別</div>
        <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
          <div class="side-search-form-radio" style="margin-bottom:0px">
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_post.gender_female" @change="resultCount()">女性</el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_post.gender_male" @change="resultCount()">男性</el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_post.gender_other" @change="resultCount()">
              その他
              <el-tooltip placement="top" content="その他：ブランド、ショップ、キャラクター/ペットなどの非人物アカウントです">
                <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px" />
              </el-tooltip>
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode" v-model="form_post.gender_null" @change="resultCount()"></el-checkbox>
          </div>
        </div>
      </div>
      <div class="side-search-form-box">
        <div class="side-search-form-title">
          PR投稿/オーガニック投稿の指定
          <el-tooltip placement="top" content="投稿画像やキャプション内容から関連カテゴリを算出します。">
            <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px" />
          </el-tooltip>
        </div>
        <el-form-item>
          <el-select
            class="sidemenu-input"
            clearable
            :class="dark_mode ? 'dark' : ''"
            v-model="form_post.post_type"
            @change="resultCount()"
            style="margin-left: 0px;"
            placeholder="投稿タイプを指定"
            size="small"
          >
            <el-option :label="'全ての投稿を検索'" :value="'all'"></el-option>
            <el-option :label="'PR投稿のみを検索'" :value="'pr'"></el-option>
            <el-option :label="'オーガニック投稿のみを検索'" :value="'organic'"></el-option>
          </el-select>
        </el-form-item>
        <!-- <div class="side-search-form-title">オプション</div>
        <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
          <div class="side-search-form-radio" style="margin-bottom:0px">
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_post.pr">
              PR投稿のみを表示
              <el-tooltip placement="top">
                <div slot="content">「#PR」「#sponsored」などのPR表記のある投稿のみを表示します。</div>
                <span>
                  <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px" />
                </span>
              </el-tooltip>
            </el-checkbox>
          </div>
        </div> -->
      </div>
      <div class="side-search-form-box">
        <div class="side-search-form-title">エンゲージメント</div>
        <el-form-item label class="slider">
          <div class="block">
            <el-slider :class="dark_mode ? 'dark' : ''" v-model="form_post.engagement" :step="100" name="engagement" :marks="engagement_marks" range :max="5000" @change="resultCount()"></el-slider>
          </div>
        </el-form-item>
        <div class="side-search-form-title">EGR</div>
        <el-form-item label>
          <div class="block">
            <el-slider :class="dark_mode ? 'dark' : ''" v-model="form_post.engagement_rate" :step="0.5" name="egr" :marks="average_engagement_rate_marks" range :max="10" @change="resultCount()"></el-slider>
          </div>
        </el-form-item>
        <!-- フォロワー数 -->
        <div class="side-search-form-title">フォロワー数</div>
        <el-form-item label>
          <div class="block">
            <el-slider
                :class="dark_mode ? 'dark' : ''"
                v-model="form_post.followers"
                range
                :min="0"
                :max="500000"
                :step="5000"
                :marks="followers_marks"
                @change="resultCount()"
            ></el-slider>
          </div>
        </el-form-item>
      </div>
    </div>

    <div class="side-search-form-button" :class="dark_mode ? 'dark' : ''">
      <el-button size="small" :type="dark_mode ? 'info' : 'default'" @click="resetParams()" style="margin-right:10px;" :class="dark_mode ? 'dark' : ''">リセット</el-button>
      <div style="display:flex; flex:1">
        <el-button size="small" native-type="submit" type="primary" @click="mediaSearch()" style="width:100%" :class="dark_mode ? 'dark' : ''">
          検索
        </el-button>
      </div>
    </div>
  </el-form>
</template>

<script>
const root = process.env.VUE_APP_API;
const resultCountAPI = root + "/api/search/result_count_post";

export default {
  name: "sidemenuPost",
  data() {
    return {
      result_count: "",
      average_engagement_rate_marks: {
        10: "10%+",
      },
      engagement_marks: {
        5000: "5K+",
      },
      followers_marks: {
        500000: "500k+",
      },
      actionId: +new Date(),
      requestId: +new Date(),
      result_loading: false,
      language: "jp",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
    form_post() {
      return this.$store.state.form_post;
    },
    form_post_initial() {
      return this.$store.state.form_post_initial;
    },
    media_search() {
      return this.$store.state.media_search;
    },
  },
  mounted() {},
  methods: {
    resultCount() {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      params.append("params", JSON.stringify(this.form_post));
      this.axios
        .post(resultCountAPI, params, { requestId: this.requestId })
        .then(() => {
          this.$store.dispatch("form_post", this.form_post);
        })
        .catch(() => {
        });
    },
    mediaSearch() {
      if (this.form_post.keyword == "" && ['all','organic'].includes(this.form_post.post_type)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "「PR投稿のみを検索」以外はキーワードが必須です",
        });
      } else {
        this.form_post.search_type = "feed";
        var form_post = Object.assign({}, this.form_post);
        this.$store.dispatch("media_search", form_post);
        this.$router.push({
          name: "media",
          query: { actionId: (this.actionId += 1) },
          params: { result_count: this.result_count_media },
        });
      }
    },
    resetParams() {
      this.$store.dispatch("form_post", Object.assign({}, this.form_post_initial)).then(() => {
        this.resultCount();
      });
    },
  },
};
</script>
